import { gql } from '@apollo/client'

export const QUERY = gql`
  query App2WorklistQuery($maxAgeDays: Int, $actionableOnly: Boolean) {
    app2Worklist(maxAgeDays: $maxAgeDays, actionableOnly: $actionableOnly) {
      items {
        applicationId
        pmName
        twoDotsStatus
        needsAttentionAt
        evieAdvisedClosedAt
        daysSinceLastChange
        topFindingSeverity
        topFindingCategory
        topFindingLane
        topFindingLabel
        topFindingTitle
        clockDebtHours
        clockDebtLabel
        openFindingCount
      }
      totalBeyondCutline
    }
  }
`
